/** 칠이 오지 않을 때(rAF 가 멈춘 숨은 탭) 더 기다리지 않는 상한 */
const PAINT_WAIT_LIMIT_MS = 100;

/**
 * 지금 DOM 에 반영된 화면이 칠해진 뒤 풀린다 — rAF 콜백 안에서 건 0ms 타이머는 그 프레임을 칠한 다음 작업으로 돈다.
 * 숨은 탭처럼 rAF 가 오지 않으면 상한 뒤에 풀린다.
 * 로그인 계산(SRP)이 메인 스레드를 붙잡기 전에 진행 표시를 화면에 올려 두는 데 쓴다(marketing-auth-pages 「요청 중 진행 표시」).
 */
export const afterNextPaint = (): Promise<void> =>
  new Promise((resolve) => {
    let frame = 0;
    const limitTimer = setTimeout(() => {
      cancelAnimationFrame(frame);
      resolve();
    }, PAINT_WAIT_LIMIT_MS);
    frame = requestAnimationFrame(() => {
      setTimeout(() => {
        clearTimeout(limitTimer);
        resolve();
      }, 0);
    });
  });
